import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { get } from 'lodash'

import { reqBuildingInfo, reqBuilding, reqApartment, reqRoom } from '../actions/measurementsActions'
import { locationFromAppId } from '../utils'

import LocationMonitor from '../Shared/LocationMonitor'

class UserMonitor extends Component {

    componentDidMount() {
        if (!this.props.info) {
            this.props.reqBuildingInfo()
        }
    }

    requestData = (apartment, room, time) => {
        if (apartment === 'all') {
            return this.props.reqBuilding(time)
        }
        else if (apartment !== 'all' && room === 'all') {
            return this.props.reqApartment(time, apartment)
        }
        else if (room !== 'all') {
            return this.props.reqRoom(time, apartment, room)
        }
    }

    render() {
        const { location, measurements, loadingInfo, privateLink } = this.props

        return (
            <div>

                <LocationMonitor
                    location={location}
                    data={measurements}
                    requestData={this.requestData}
                    loadingInfo={loadingInfo}
                />

                <div style={{ marginTop: '20px' }}>
                    <Button primary as={Link} to={`/asiakkaat/${privateLink}`}>
                        <Icon name="arrow left" />
                        Takaisin
                    </Button>
                </div>

            </div>
        )
    }
}

const mapStoP = (state, ownProps) => {
    const appId = ownProps.match.params.id
    const privateLink = ownProps.match.params.privatelink
    return {
        location: locationFromAppId(appId),
        loadingInfo: state.measurements.loadingInfo,
        privateLink: privateLink,
        measurements: {
            apartmentsAndRooms: state.measurements.info[appId] || [],
            hourly: {
                building: get(state.measurements.hourlyBuilding, appId) || [],
                apartment: get(state.measurements.hourlyApartment, appId) || {},
                room: get(state.measurements.hourlyRoom, appId) || {}
            },
            daily: {
                building: get(state.measurements.dailyBuilding, appId) || [],
                apartment: get(state.measurements.dailyApartment, appId) || {},
                room: get(state.measurements.dailyRoom, appId) || {}
            },
            weekly: {
                building: get(state.measurements.weeklyBuilding, appId) || [],
                apartment: get(state.measurements.weeklyApartment, appId) || {},
                room: get(state.measurements.weeklyRoom, appId) || {}
            },
            monthly: {
                building: get(state.measurements.monthlyBuilding, appId) || [],
                apartment: get(state.measurements.monthlyApartment, appId) || {},
                room: get(state.measurements.monthlyRoom, appId) || {}
            }
        },
        info: state.measurements.info[appId]
    }
}

const mapDtoP = (dispatch, ownProps) => {
    const appId = ownProps.match.params.id
    const privateLink = ownProps.match.params.privatelink
    return {
        reqBuildingInfo: () => dispatch(reqBuildingInfo(appId, privateLink)),
        reqBuilding: (time) => dispatch(reqBuilding(appId, time, privateLink)),
        reqApartment: (time, apartment) => dispatch(reqApartment(appId, time, apartment, privateLink)),
        reqRoom: (time, apartment, room) => dispatch(reqRoom(appId, time, apartment, room, privateLink)),
    }
}

export default connect(mapStoP, mapDtoP)(UserMonitor)


// WEBPACK FOOTER //
// ./src/User/UserMonitor.js